/**
 * Shrink header on scroll
 * 
 * @since 1.0.0
 * @package crunchy
 */
(function($) {

	var headerSelector = 'header[role="banner"]';
	var header         = $( headerSelector );
	var preHeader      = $( 'section +' + headerSelector ).prev();

	// in case there's a banner pre-header
	if ( preHeader.length < 1 ) {
		preHeader = $( '.banner +' + headerSelector ).prev();
	}

	// do we have a pre-header layout?
	// set its height.
	var preScroll = preHeader.length > 0 ? preHeader.outerHeight( true ) : 0;


	$( document ).on( 'scroll', function() {

		// get scroll distance
		var scrolled = $( document ).scrollTop();

		// stick it
		if ( preScroll && scrolled >= preScroll ) {
			header.addClass( 'stick' );
		} else {
			header.removeClass( 'stick' );
		}

		// scrolled style
		if ( scrolled > 80 + preScroll ) {
			header.addClass( 'scrolled' );
		} else {
			header.removeClass( 'scrolled' );
		}
		
	}); // document.ready
})(jQuery);